/* eslint-disable sonarjs/cognitive-complexity */
import { createElementFromStringUnsafe } from '../../helpers/index';

const testElementForAdv = function (item) {
	const isNextHasStrong = (item.nextElementSibling.children.length > 0 && item.nextElementSibling.children[0].tagName !== 'STRONG') || item.nextElementSibling.children.length === 0;
	return item.tagName === 'P' && item.nextElementSibling.tagName === 'P' && item.nextElementSibling.nextElementSibling.tagName === 'P' && isNextHasStrong;
};

const insertInreadAdvs = function (inreads, node) {
	let articleContainer = null;

	if (node) {
		articleContainer = node;
	} else {
		articleContainer = document.querySelector('.grid-container');
	}

	console.info('[ads] Floating Ads: ' + articleContainer?.dataset.floatingAdsDisabled);

	console.info('[ads] Floating Ads starting');

	if (articleContainer?.dataset.floatingAdsDisabled === 'false') {
		console.info('[ads] Floating Ads on');

		const articleBody = articleContainer ? articleContainer.querySelector('.article .content') : document.querySelector('.article .content');
		const windowHeight = window.innerHeight;
		let wasntIncludedInreads = false;

		if (inreads.length > 0 && articleBody !== null) {
			const description = articleContainer ? articleContainer.querySelector('.preview__text') : document.querySelector('.preview__text');
			const pictureGroup = articleContainer ? articleContainer.querySelector('figure') : document.querySelector('figure');

			let advsGap = (description !== null ? description.offsetHeight : 0) + (pictureGroup !== null ? pictureGroup.offsetHeight : 0);
			for (let i = 0; i < articleBody.childElementCount - 2; i++) {
				if (inreads.length === 0) {
					break;
				}

				const item = articleBody.children[i];
				if (item.classList.contains('additional')) {
					advsGap = windowHeight > advsGap ? advsGap - 300 : windowHeight - 300;
				} else {
					advsGap += item.offsetHeight;
				}

				if (advsGap > windowHeight && testElementForAdv(item)) {
					advsGap = 0;
					try {
						item.insertAdjacentElement('afterend', createElementFromStringUnsafe(inreads.pop()));
						wasntIncludedInreads = false;
						console.info('[ads] successfully');
					} catch (error) {
						console.error('[ads] error: ' + error);
					}
				} else {
					wasntIncludedInreads = true;
				}
			}
			console.info('[ads] Floating Ads: ' + !articleContainer?.dataset.floatingAdsDisabled);
		} else {
			console.info('[ads] Floating Ads: not included');
		}

		if (wasntIncludedInreads) {
			console.info('[ads] Floating Ads: inreads count ' + inreads.length);
			const RESP_UN_MAIN_PHOTO = articleContainer.querySelector('.resp-un-main-photo');
			if (RESP_UN_MAIN_PHOTO) {
				console.info('[ads] Floating Ads: off and include resp-un-main-photo');
				RESP_UN_MAIN_PHOTO.classList.remove('hidden');
			}
		}
	} else {
		console.info('[ads] Floating Ads: turned off');
	}
};

export default insertInreadAdvs;
